var XLSXExportUtils =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ({

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// Bundle all utilities into a single module
var ODataDataProvider = __webpack_require__(37);
var FileSaver = __webpack_require__(39);

module.exports = {
	oData: {
		fetch: ODataDataProvider.requestData,
		getConverter: ODataDataProvider.getConverter
	},
	saveFile: FileSaver.saveFile
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var RequestHandler = __webpack_require__(38);

var MAX_ROWS = 1000000; // 1,000,000

/**
 * OData interface for requesting chunked data.
 */

/**
 * Gets converted property value from raw data.
 * Navigation properties are parsed.
 *
 * @param {Object} oRow - Raw data row
 * @param {Object} oCol - Column information
 * @param {Array} oCol.keys - Property name or key path for navigation properties
 * @returns {number|string|boolean} - The converted property value
 * @private
 */
function getValue(oRow, oCol) {

	// Get property value
	var value = oCol.keys.reduce(function(obj, key) {
		return obj && obj[key];
	}, oRow);

	return value;
}

/**
 * Function to process the JSON result array from a ODataService.
 *
 * @param {Array} aRows - Data array that contains the received data
 * @param {Array} aCols - Columns that need to be converted
 * @returns {Array} - An array of rows
 *
 * @private
 */
function convertData(aRows, aCols) {
	aCols.forEach(function(col) {
		aRows.forEach(function(row) {
			row[col.property] = getValue(row, col);
		});
	});

	return aRows;
}

/**
 * The function returns array of columns that need special conversion for values.
 * E.g. handling data from association/navigationProperty
 *
 * @param {Object} mSettings - Configuration object
 * @returns {Array} - Collection of columns that need special conversion for their values
 * @private
 */
function getColsToConvert(mSettings) {
	return mSettings.workbook.columns.reduce(function(result, col) {
		var properties;

		// Handle aggregated properties and single properties
		properties = col.property instanceof Array ? col.property : [col.property];
		// Handle unitPoperty which too could be from an association
		if (col.unitProperty) {
			properties.push(col.unitProperty);
		}

		properties.forEach(function(property) {

			// Convert navigation property and date fields
			var aKeys = property.split('/');

			if (aKeys.length > 1) {
				result.push({
					property: property,
					keys: aKeys,
					type: col.type
				});
			}
		});

		return result;
	}, []);
}

/**
 * The function returns a conversion function for raw data.
 *
 * @param {Object} mSettings Configuration object
 * @returns {function} Conversion function
 */
function getDataConverter(mSettings) {
	var aColumns = getColsToConvert(mSettings);

	return function(aRows) {
		return convertData(aRows, aColumns);
	};
}

/**
 * The function processes the dataURL and adds any missing $skip or $top before initial use.
 *
 * @param {string} sDataUrl
 * @param {number} iSkip - The amount of items that are already present and will be skipped
 * @param {number} iTop - The amount of items that should be requested with this query
 * @returns {string} processed data URL
 */
function processDataUrl(sDataUrl, iSkip, iTop) {
	var mDataUrl, reSkip = /\$skip\=[0-9]+/, reTop = /\$top\=[0-9]+/;

	if (!sDataUrl) {
		return '';
	}

	mDataUrl = URI.parse(sDataUrl);

	mDataUrl.query = mDataUrl.query || '';
	// Add missing $skip if needed
	if (!reSkip.test(mDataUrl.query)) {
		mDataUrl.query += (mDataUrl.query.length ? '&' : '') + '$skip=' + iSkip;
	}
	// Add missing $top if needed
	if (!reTop.test(mDataUrl.query)) {
		mDataUrl.query += '&$top=' + iTop;
	}

	return (URI.serialize || URI.build)(mDataUrl);
}

/**
 * The function requests several chunks of data until the maximum
 * amount of data is fetched.
 *
 * @param {Object} mSettings - Configuration object
 * @param {function} fnProcessCallback - Callback function that is triggered when data is received
 * @returns {Object} - Object reference that allows to cancel the current processing
 */
function requestData(mSettings, fnProcessCallback) {
	var iAvailableRows = 0;
	var mDataSource = mSettings.dataSource;
	var iTotalRows = Math.min(mDataSource.count || MAX_ROWS, MAX_ROWS);
	var iBatchSize = Math.min(mDataSource.sizeLimit || MAX_ROWS, mSettings.batchSize || MAX_ROWS, iTotalRows);
	var bCancelled = false;
	var dataUrl = processDataUrl(mDataSource.dataUrl, 0, iBatchSize);
	var fnConvertData = getDataConverter(mSettings);
	var mRequest;

	/**
	 * Nested function to remove not used information from the URL
	 *
	 * @param {string} url - A URL that may contain a path, hash and request parameters
	 * @returns {string} - A clean URL
	 */
	function cleanUrl(url) {
		var mUri;

		if (!url) {
			return '';
		}

		mUri = URI.parse(url);

		mUri.path = mUri.path || '';
		if (mUri.path.slice(-1) !== '/') {
			mUri.path = mUri.path + '/';
		}
		delete mUri.query;
		delete mUri.hash;
		delete mUri.fragment;

		return (URI.serialize || URI.build)(mUri);
	}


	/**
	 * Creates the download URL for the next query.
	 *
	 * @param {number} iSkip - The amount of items that are already present and will be skipped
	 * @param {number} iTop - The amount of items that should be requested with this query
	 * @param {string} sNextUrl - A reference to the next bulk of data that was returned by the previous request
	 * @returns {string} - The URL for the next query
	 */
	function getUrl(iSkip, iTop, sNextUrl) {
		var mDataUrl, mNextUrl;

		mDataUrl = URI.parse(dataUrl);

		/*
		 * Use $skiptoken from response to query the next items.
		 * OData V4 returns a relative path, while OData V2 returns
		 * an absolute path. Therefore we need to use the original
		 * URL to keep possible proxy settings and avoid any issues
		 * between OData V4 and V2
		 */
		if (sNextUrl) {
			mNextUrl = URI.parse(sNextUrl);
			mDataUrl.query = mNextUrl.query;
		} else { // Use $skip and $top
			mDataUrl.query = (mDataUrl.query || '')
				.replace(/\$skip\=[0-9]+/g, '$skip=' + iSkip)
				.replace(/\$top\=[0-9]+/g, '$top=' + iTop);
		}

		return (URI.serialize || URI.build)(mDataUrl);
	}

	/**
	 * Inner function that processes request handler exceptions.
	 *
	 * @param {string} sMessage - Error message.
	 */
	function fnOnError(sMessage) {
		fnProcessCallback({
			error: sMessage
		});
	}

	/**
	 * Inner function that processes the received data. Processing
	 * the data before executing the callback function allows to
	 * apply transformations to the data.
	 *
	 * @param {Object} oResult - The result object that is provided by the Promise resolve.
	 */
	function fnOnDataReceived(oResult) {
		var aData, sNextUrl, iFetchedRows, fPercent, iRemainingRows;
		var mCallbackParams = {};

		if (bCancelled) {
			return; // Cancelled by the application
		}

		/* Check for OData V4 result, if not present check for OData V2 result or apply default */
		aData = (oResult && oResult.value || (oResult.d && (oResult.d.results || oResult.d))) || oResult;
		aData = (Array.isArray(aData)) ? aData : [];
		iFetchedRows = aData.length;

		iAvailableRows += iFetchedRows;
		iRemainingRows = iTotalRows - iAvailableRows;
		fPercent = iAvailableRows / iTotalRows;

		mCallbackParams.finished = iFetchedRows === 0 || iRemainingRows <= 0; // Done criteria
		mCallbackParams.progress = Math.round(fPercent * 100);

		// Check if next url is provided
		sNextUrl = (oResult && oResult['@odata.nextLink'] || (oResult.d && oResult.d.__next)) || null;

		if (!mCallbackParams.finished) {
			// Trigger next page request before processing received data. Fetch only configured/max limit rows
			mRequest.dataUrl = getUrl(iAvailableRows, Math.min(iBatchSize, iRemainingRows), sNextUrl);
			RequestHandler
				.sendRequest(mRequest)
				.then(fnOnDataReceived)
				.catch(fnOnError);
		}

		mCallbackParams.rows = fnConvertData(aData); // Normalize data
		fnProcessCallback(mCallbackParams); // Return result
	}

	// Execution
	mRequest = {
		serviceUrl: cleanUrl(mDataSource.serviceUrl),
		dataUrl: getUrl(0, iBatchSize),
		method: mDataSource.useBatch ? 'BATCH' : 'GET',
		headers: mDataSource.headers
	};

	RequestHandler
		.sendRequest(mRequest)
		.then(fnOnDataReceived)
		.catch(fnOnError);

	return { cancel: function() { bCancelled = true; } };
}

module.exports = {
	requestData: requestData,
	getConverter: getDataConverter
};

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

/**
 * Returns a promise that is resolved once the data is fetched
 */

var HTTP_ERROR_MSG = 'HTTP connection error';
var HTTP_WRONG_RESPONSE_MSG = 'Unexpected server response:\n';

/**
 * This method creates an XMLHttpRequest from the provided
 * configuration and requests the data from the backend. The
 * configuration is configured to use OData services.
 *
 * @param {Object} oRequest - Request configuration object
 * @param {string} oRequest.method - References the HTTP method that is used (default: GET)
 * @param {string} oRequest.url - References the resource URL that gets invoked
 * @return {Promise} Returns a Promise that will be resolve once the requested data was fetched
 */
function sendRequest(oRequest) {
	if (typeof oRequest !== 'object' || oRequest === null || typeof oRequest.dataUrl !== 'string') {
		throw new Error('Unable to send request - Mandatory parameters missing.');
	}

	return (oRequest.method === 'BATCH' && oRequest.serviceUrl ? sendBatchRequest : sendGetRequest)(oRequest);
}

/**
 * Creates and sends a GET request to the backend service.
 *
 * @param {Object} oRequest - Request object that contains all necessary information to create the batch request
 * @returns {Promise} - A Promise that resolves in a JSON object containing the fetched data
 */
function sendGetRequest(oRequest) {
	return new Promise(function(fnResolve, fnReject) {
		var sHeaderKey;
		var xhr = new XMLHttpRequest();

		xhr.onload = function() {
			if (this.status >= 400) {
				fnReject(this.responseText);

				return;
			}
			try {
				fnResolve(JSON.parse(this.responseText));
			} catch (e) {
				fnReject(HTTP_WRONG_RESPONSE_MSG + this.responseText);
			}
		};
		xhr.onerror = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.onabort = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.open('GET', oRequest.dataUrl, true);
		xhr.setRequestHeader('accept', 'application/json');

		/* Set custom header information on the request as well as on the batch request */
		for (sHeaderKey in oRequest.headers) {
			if (sHeaderKey.toLowerCase() != 'accept') {
				xhr.setRequestHeader(sHeaderKey, oRequest.headers[sHeaderKey]);
			}
		}

		xhr.send();
	});
}

/**
 * Creates a pseudo random GUID. This algorithm is not suitable for
 * cryptographic purposes and should not be used therefore.
 *
 * @returns {string} - Generated GUID
 */
function createGuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, // Bitwise OR is equivalent to Math.floor() but faster
			v = c === 'x' ? r : ((r & 0x3) | 0x8); // In case of c != 'x', the value is always between 0x8 and 0xB

		return v.toString(16);
	});
}

/**
 * Creates a $batch request and sends it to the backend service.
 *
 * @param {Object} oRequest - Request object that contains all necessary information to create the batch request
 * @returns {Promise} - A Promise that resolves in a JSON object containing the fetched data
 */
function sendBatchRequest(oRequest) {
	return new Promise(function(fnResolve, fnReject) {
		var xhr = new XMLHttpRequest();
		var boundary = 'batch_' + createGuid();
		var getUrl = oRequest.dataUrl.split(oRequest.serviceUrl)[1];
		var body = [];
		var sKey, sValue;

		xhr.onload = function() {
			var responseText, aLines, iEnd, iLength, iStart, oResponseData;

			responseText = this.responseText;
			aLines = this.responseText.split('\r\n');

			// TBD: check return codes
			iStart = 0;
			iLength = aLines.length;
			iEnd = iLength - 1;

			while (iStart < iLength && aLines[iStart].slice(0, 1) !== '{') {
				iStart++;
			}

			while (iEnd > 0 && aLines[iEnd].slice(-1) !== '}') {
				iEnd--;
			}
			aLines = aLines.slice(iStart, iEnd + 1);
			responseText = aLines.join('\r\n');

			try {
				oResponseData = JSON.parse(responseText);
				fnResolve(oResponseData);
			} catch (e) {
				fnReject(HTTP_WRONG_RESPONSE_MSG + responseText);
			}
		};
		xhr.onerror = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.onabort = function() {
			fnReject(HTTP_ERROR_MSG);
		};

		// Create request
		xhr.open('POST', oRequest.serviceUrl + '$batch', true);

		xhr.setRequestHeader('Accept', 'multipart/mixed');
		xhr.setRequestHeader('Content-Type', 'multipart/mixed;boundary=' + boundary);

		body.push('--' + boundary);
		body.push('Content-Type: application/http');
		body.push('Content-Transfer-Encoding: binary');
		body.push('');
		body.push('GET ' + getUrl + ' HTTP/1.1');

		/* Set header information on the request as well as on the batch request */
		for (sKey in oRequest.headers) {
			sValue = oRequest.headers[sKey];

			if (sKey.toLowerCase() != 'accept') {
				xhr.setRequestHeader(sKey, sValue);
			}
			body.push(sKey + ':' + sValue);
		}

		body.push('');
		body.push('');
		body.push('--' + boundary + '--');
		body.push('');
		body = body.join('\r\n');
		xhr.send(body);
	});
}

module.exports = { sendRequest: sendRequest };

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

/**
 * The FileSaver allows to save browser generated files to
 * the local computer without using a proxy service.
 *
 * This class supports the latest version of the following browsers:
 *
 * Microsoft Internet Explorer 11
 * Microsoft Edge
 * Google Chrome
 * Mozilla Firefox
 * MacOS Safari
 * iOS Safari
 * Chrome for Android
 * SAP Fiori Client
 */

/**
 * This function saves the provided Blob to the local file system.
 * The parameter name is optional and depending on the browser it
 * is not ensured that the filename can be applied. Google Chrome,
 * Mozilla Firefox, Internet Explorer and Microsoft Edge will
 * apply the filename correctly.
 *
 * @param {Blob} blob - Binary large object of the file that should be saved to the filesystem
 * @param {string} [name] - Filename of the file including the file extension
 */
function saveFile(blob, name) {
	var link, downloadSupported, fnSave;

	/* Ignore other formats than Blob */
	if (!(blob instanceof Blob)) {
		return;
	}

	link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
	downloadSupported = 'download' in link;

	/* Try ObjectURL Chrome, Firefox, Opera, Android, Safari (Desktop ab 10.1) */
	if (downloadSupported) {
		fnSave = function(data, fileName) {
			link.download = fileName;
			link.href = URL.createObjectURL(data);
			link.dispatchEvent(new MouseEvent('click'));
		};
	}

	/* In case of iOS Safari, MacOS Safari */
	if (typeof fnSave === 'undefined') {
		fnSave = function(data) {
			var reader = new FileReader();

			reader.onloadend = function() {
				var opened, url;

				url = reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
				opened = window.open(url, '_blank');

				if (!opened) {
					window.location.href = url;
				}
			};
			reader.readAsDataURL(blob);
		};
	}

	/*
	 * IE/Edge implementation
	 *
	 * Microsoft Edge also supports the download attribute but ignores the value of the attribute.
	 * This is why we override it with the navigator.msSaveOrOpenBlob function in case of MS Edge.
	 */
	if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
		fnSave = function(data, fileName) {
			window.navigator.msSaveOrOpenBlob(data, fileName);
		};
	}

	/* Save file to device */
	fnSave(blob, name);
}

module.exports = { saveFile: saveFile };

/***/ })

/******/ });


// WEBPACK FOOTER //
// XLSXExportUtils.js